import { render } from "./ModelVersionTable.vue?vue&type=template&id=534c87a4"
import script from "./ModelVersionTable.vue?vue&type=script&lang=js"
export * from "./ModelVersionTable.vue?vue&type=script&lang=js"

import "./ModelVersionTable.vue?vue&type=style&index=0&id=534c87a4&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__